"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFERROR = void 0;
const INTERNAL_ERROR_TOKEN = '___FORMULA_ENGINE_ERROR_TOKEN__';
exports.IFERROR = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 2, max: 2 },
    },
    errorHandler: ({ idx }) => {
        let token = null;
        if (idx === 0) {
            token = INTERNAL_ERROR_TOKEN;
        }
        return { token };
    },
    evaluate: (inputs) => {
        if (inputs[0] !== INTERNAL_ERROR_TOKEN) {
            return { error: null, result: inputs[0] };
        }
        return { error: null, result: inputs[1] };
    },
};
//# sourceMappingURL=iferror.js.map